import '@/styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { env } from '@/config/env';
import { initI18n } from '@/i18n/i18n';
import { logger } from '@/lib/logger';

import { App } from './App';
import { AppProviders } from './AppProviders';

const root = document.getElementById('root');
if (root === null) throw new Error('Root element #root is missing from index.html');
const rootElement: HTMLElement = root;

// Fallback product name until merchant branding resolves. Importing `env` here also means its
// Zod validation runs before the first render, so a misconfigured deployment fails at boot
// rather than mid-payment.
document.title = env.appName;

async function bootstrap(): Promise<void> {
  try {
    await initI18n();
  } catch (error) {
    logger.error('[i18n] init failed', { error });
  }

  createRoot(rootElement).render(
    <StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
